import apiClient from 'src/utils/apiClient';

// **** Types **** //

export interface FeatureFlagsPayload {
  placement_transfer: boolean;
  decision_portal: boolean;
  correspondence: boolean;
  atoz_notifications: boolean;
  job_modifications: boolean;
  persona: boolean;
  task_grouping: boolean;
  t2_plus_experience: boolean;
  new_modified_duty_experience: boolean;
}

// **** Functions **** //

/**
 * Fetch an object with the list of feature flags. If there's an issue with the API, use
 * the hardcoded values in the catch statement.
 */
async function getFeatureFlags(): Promise<FeatureFlagsPayload> {
  try {
    const { data } = await apiClient.get<FeatureFlagsPayload>('/featureFlags');
    return data;
  } catch {
    return {
      placement_transfer: true,
      decision_portal: true,
      atoz_notifications: true,
      job_modifications: true,
      correspondence: true,
      persona: false,
      task_grouping: false,
      t2_plus_experience: false,
      new_modified_duty_experience: false,
    };
  }
}

/**
 * Update a particular feature flag.
 */
async function updateFeatureFlag(featureName: string, isEnabled: boolean): Promise<FeatureFlagsPayload> {
  const { data } = await apiClient.put<FeatureFlagsPayload>(`/featureFlags/${featureName}?enabled=${isEnabled}`);
  return data;
}

// **** Export default **** //

export default {
  getFeatureFlags,
  updateFeatureFlag,
} as const;
